import { useAtomValue } from "jotai";
import useGlobalModal from "../../hooks/useGlobalModal";
import { globalModalListAtom, type GlobalModalOptions } from "../../store";

export default function GlobalModal(props: GlobalModalOptions) {
  const { removeGlobalModal } = useGlobalModal();
  const modalList = useAtomValue(globalModalListAtom);
  const currentModal = modalList?.[0];

  const Comp = currentModal?.Comp;

  const handleClose = () => {
    props.onClose?.();
    removeGlobalModal();
  };

  return <div
    className="global-modal fixed inset-0 z-[9999] bg-black/85"
    style={{ pointerEvents: 'auto' }}
    onClick={(e: React.MouseEvent) => e.stopPropagation()}
  >
    {props.clickOnClickOutside && <div className="absolute inset-0 bg-black/50" onClick={handleClose}></div>}
    {Comp && <div
      className="absolute inset-0 flex justify-center items-center z-10"
      style={{
        // zIndex: currentModal.zIndex
      }}
    >
      <Comp id={currentModal.id} data={props.params || {}} />
    </div>}
  </div>;
}